const BlOG_CATEGORY_LOADING = "BlOG_CATEGORY_LOADING";
const BlOG_CATEGORY_ERROR = "BlOG_CATEGORY_ERROR";
const BlOG_CATEGORY_SUCCESS = "BlOG_CATEGORY_SUCCESS";

export { BlOG_CATEGORY_LOADING, BlOG_CATEGORY_ERROR, BlOG_CATEGORY_SUCCESS };
